import { render, staticRenderFns } from "./vehiclesTable.vue?vue&type=template&id=65e6b77b&"
import script from "./vehiclesTable.vue?vue&type=script&lang=js&"
export * from "./vehiclesTable.vue?vue&type=script&lang=js&"
import style0 from "./vehiclesTable.vue?vue&type=style&index=0&id=65e6b77b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports